import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/i18n";
import { errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const { t } = useLang();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await register(form);
      toast.success(t("Cuenta creada. Ahora sube tu ID desde tu perfil."));
      navigate("/perfil");
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  const field = (id, label, type, key, placeholder, testid) => (
    <div>
      <Label htmlFor={id} className="text-slate-300">{label}</Label>
      <Input id={id} data-testid={testid} type={type} required value={form[key]}
        onChange={(e) => setForm({ ...form, [key]: e.target.value })}
        className="mt-1.5 bg-[#0B0F1A] border-white/15 focus:ring-2 focus:ring-blue-500" placeholder={placeholder} />
    </div>
  );

  return (
    <div className="max-w-md mx-auto px-4 py-24">
      <div className="card-tech rounded-2xl p-8">
        <h1 className="text-2xl font-bold tracking-tight mb-2">{t("Crear cuenta")}</h1>
        <p className="text-sm text-slate-400 mb-8">{t("Después del registro deberás subir tu ID (licencia o pasaporte), requisito de Copart.")}</p>
        <form onSubmit={submit} className="space-y-5" data-testid="register-form">
          {field("name", t("Nombre completo"), "text", "name", "Juan Pérez", "register-name")}
          {field("email", t("Correo electrónico"), "email", "email", "tu@correo.com", "register-email")}
          {field("phone", t("Teléfono / WhatsApp"), "tel", "phone", "+1 305 000 0000", "register-phone")}
          {field("password", t("Contraseña (mín. 6 caracteres)"), "password", "password", "••••••••", "register-password")}
          {error && <p data-testid="register-error" className="text-sm text-red-400 bg-red-500/10 border border-red-500/30 rounded-lg px-3 py-2">{error}</p>}
          <Button data-testid="register-submit" type="submit" disabled={loading}
            className="w-full bg-[#2563EB] hover:bg-[#1D4ED8] text-white rounded-full h-11">
            {loading ? t("Creando...") : t("Crear cuenta")}
          </Button>
        </form>
        <p className="text-sm text-slate-400 mt-6 text-center">
          {t("¿Ya tienes cuenta?")} <Link to="/login" className="text-[#2563EB] hover:text-blue-400 transition-colors">{t("Entrar")}</Link>
        </p>
      </div>
    </div>
  );
}
